export module DateDiff{
    export function getMilliseconds(dataInizio: Date, dataFine: Date): number {
        return (dataFine.getTime() - dataInizio.getTime());
    }
    export function getSeconds(dataInizio: Date, dataFine: Date): number {
        return Math.ceil(getMilliseconds(dataInizio, dataFine) / 1000);
    }
    export function getMinutes(dataInizio: Date, dataFine: Date): number {
        return Math.ceil(getSeconds(dataInizio, dataFine) / 60);
    }
    export function getHours(dataInizio: Date, dataFine: Date): number {
        return Math.floor(getMinutes(dataInizio, dataFine) / 60);
    }
    export function getDays(dataInizio: Date, dataFine: Date): number {
        return Math.floor(getHours(dataInizio, dataFine) / 24);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/functions/date-diff.ts